import { State } from '../../../../../interfaces/merchants/resources/books/inputs';

export const getMerchantResourcesBooksInputs = (state: State) => state;
